import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';

import { getTextAlignClass, getVerticalAlignClass } from './GridColumnFlex.utils';
import './GridColumnFlex.css';


const propTypes = {
  className: PropTypes.string,
  textAlign: TextAlignPropType,
  verticalAlign: VerticalAlignPropType,
};

const defaultProps = {
  className: undefined,
  textAlign: 'center',
  verticalAlign: 'middle',
};


function GridColumnFlex({textAlign, verticalAlign, className, ...passThroughProps}) {
  const allClassNames = [
    className,
    getTextAlignClass(textAlign),
    getVerticalAlignClass(verticalAlign),
  ].join(' ');

  return (
    <Grid.Column className={`grid-column-flex ${allClassNames}`} {...passThroughProps} />
  );
};


GridColumnFlex.propTypes = propTypes;
GridColumnFlex.defaultProps = defaultProps;

export default GridColumnFlex;
